module.exports = __webpack_public_path__ + "static/media/logo-sala-virtual.8cf96c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-sala-virtual.png
// module id = 1773
// module chunks = 0